var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "jgqs-content" },
    [
      _c("v-title", { attrs: { item: _vm.sjObj } }, [
        _vm._v(_vm._s(_vm.sjObj.name)),
      ]),
      _c("div", { ref: "chart", staticClass: "chart" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }